<template>
  <div id="app" :class="getAppClass" ref="app">
    <router-view />
    <div id="full-loading" v-if="isLoading" @wheel.prevent>
      <i class="el-icon-loading"></i>
      <p>{{ getLoadingText }}</p>
      
    </div>
    <transition name="fade">
      <pic-mask
        v-if="picMaskShow"
        :imgSrc="activeImgSrc"
        :imgDeg="activeImgDeg"
        @closePicMask="picMaskShow = false"
      />
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import isMac from '@/assets/js/systemIdenty'
import PicMask from '@/components/pic-mask'
export default {
  provide() {
    return {
      bodyLoad: (bool, txt) => {
        if (bool) {
          this.loadText = txt || '加载中'
          this.isLoading = bool
          this.loadClock = setInterval(() => {
            this.loadingStatus++
            if (this.loadingStatus > 3) {
              this.loadingStatus = 1
            }
          }, 300)
        } else {
          clearInterval(this.loadClock)
          this.loadClock = null
          this.loadingStatus = 0
          this.isLoading = false
        }
      },
      showLargeImage: (src, deg) => {
        this.activeImgSrc = src
        if (deg) this.activeImgDeg = deg
        else this.activeImgDeg = 0
        if (this.screenWidth > 968) this.picMaskShow = true
      }
    }
  },
  components: {
    PicMask
  },
  data() {
    return {
      isWin: true,
      isLoading: false,
      loadText: '',
      loadingStatus: 0,
      loadClock: null,
      activeImgSrc: '',
      activeImgDeg: 0,
      picMaskShow: false
    }
  },
  computed: {
    ...mapState(['screenWidth']),
    getLoadingText() {
      let str = ''
      for (let i = 0; i < this.loadingStatus; i++) {
        str += ' . '
      }
      return this.loadText + str
    },
    getAppClass() {
      let str = this.isWin ? 'win' : 'mac'
      str += this.screenWidth <= 968 ? ' mobile' : ''
      return str
    }
  },
  created() {
    if (isMac) {
      this.isWin = false
    }
  },
  mounted() {
    this.setScreenWidth()
    // window.addEventListener("resize",this.setScreenWidth);
    window.addEventListener('resize', this.setScreenWidth)
  },
  methods: {
    // setScreenWidth() {
    // this.$store.commit("setScreenWidth",this.$refs.app.offsetWidth);
    // },
    setScreenWidth() {
      this.$store.commit('screenHeightttt', this.$refs.app.offsetHeight)
      this.$store.commit('screenWidthhhhh', document.body.offsetWidth)
    }
  },
  beforeDestroy() {
    clearInterval(this.loadClock)
    this.loadClock = null
    this.loadingStatus = 0
    this.isLoading = false
    window.removeEventListener('resize', this.setScreenWidth)
  }
}
</script>

<style lang="scss">
@import './assets/css/class';
#app {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  min-width: 375px;
  // min-height: 800px;
  color: #333;
  &.mobile {
    min-height: 600px;
  }
}
#full-loading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 3005;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  i {
    font-size: 40px;
    margin-bottom: 20px;
  }
}
.win {
  font-family: '微软雅黑', Arial;
  font-weight: 500;
  a {
    font-family: '微软雅黑', Arial;
    font-weight: 500;
  }
}
.mac {
  font-family: 'PingFangSC-Medium', 'SF UI Text';
  a {
    font-family: 'PingFangSC-Medium', 'SF UI Text';
  }
}
.el-message-box,
.el-dialog {
  max-width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue